import * as PropTypes from 'prop-types'

const AccountingSeatSettingShape = PropTypes.shape({

})

export { AccountingSeatSettingShape }
